<template>
  <div class="modal-field">
    <button class="modal-field__close-btn" @click="closeModal">
      <BaseIcon name="cross" />
    </button>
    <h1 class="modal-field__title" v-html="modalData.message"></h1>

    <div class="modal-field__buttons">
      <BaseButton title="OK" @click.native="closeModal"/>
    </div>
  </div>
</template>

<script>
  import { MDSModalHintModel } from '@/models/modal-datasets.model'

  export default {
    props: {
      modalData: MDSModalHintModel
    },
    methods: {
      closeModal () {
        this.$store.commit('modals/CLOSE_LAST_MODAL')
      },
      handleKeyEvent (e) {
        if (e.keyCode === 13) {
          this.closeModal()
        }
      }
    },
    mounted () {
      document.addEventListener('keydown', this.handleKeyEvent)
    },
    beforeDestroy () {
      document.removeEventListener('keydown', this.handleKeyEvent)
    }
  }
</script>

<style lang="scss" src="./modal-field.scss"></style>



// WEBPACK FOOTER //
// src/components/modals/modals-content/ModalHint.vue